module.exports = __webpack_public_path__ + "img/vip-img3.75499011.png";